<template>
  <div class="custom-group-tours-benefits mb-54 mb-mb-20" :class="bg ? `bg-${bg}` : ''">
    <div class="container">
      <div class="text flex flex-wrap mb-flex-column justify-between items-end mb-40">
        <div class="flex fw-700 flex-column justify-start mt-100">
          <h2
            class="fs-40 mb-fs-32 fw-700 mb-fs-32 lh-52 mb-lh-42 mb-8 ls-1"
            v-html="headerText"
          />
          <p class="fs-16 lh-20 gray-dark ls-1 mb-0 mb-mb-24">
            {{  $route.name === SCHOOL_TOUR_ROUTE.name ? SCHOOL_BENEFITS_SUBHEADER : BENEFITS_SUBHEADER }}
          </p>
        </div>
        <CGTButtons class="mt-24 mb-mt-0" title="Enquire now" color="yellow" />
      </div>
      <div class="content" :class="{ fade: shouldFade }">
        <div :style="$route.name === SCHOOL_TOUR_ROUTE.name ? 'max-width: 640px;' : 'max-width: 100%;'"
          class="
            flex
            mb-flex-column
            pt-16
            pb-30
            tl-grid-gap-16
            mb-mr-35
            items-center
            flex-wrap
          "
        >
          <CGTBenefitsCard
            v-for="(item, key) in content"
            :key="key"
            :title="item.title"
            :content="item.content"
            :icon="item.icon"
          />
        </div>
      </div>
      <button
        v-if="!clicked && shouldFade"
        class="button button-white-transparent mb-wp-100"
        @click="showMore"
      >
        Show more
        <img
          class="ml-8"
          :src="`${ASSETS_CDN}/icons/expand_more.svg`"
          alt="expand arrow"
        />
      </button>
    </div>
  </div>
</template>

<script setup>
import { PHONE } from '~/constant/common'
import {
  BENEFITS_HEADER,
  BENEFITS_SUBHEADER,
  BENEFITS_FIRST_LIST,
  BENEFITS_SECOND_LIST,
} from '~/constant/customGroupTours'
import {
  SCHOOL_BENEFITS_HEADER,
  SCHOOL_BENEFITS_SUBHEADER,
  SCHOOL_BENEFITS_FIRST_LIST,
  SCHOOL_BENEFITS_SECOND_LIST,
} from '~/constant/schoolTourDetails'
import CGTButtons from '~/components/pages/LandingPage/components/CGTButtons.vue'
import CGTBenefitsCard from '~/components/pages/LandingPage/CGTBenefits/CGTBenefitsCard.vue'
import { computed, onMounted, ref, watch } from 'vue'
import { assetCDN } from '~/helper'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'
import { useRoute } from 'vue-router'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common.js'

// Even-odd section background — page passes 'cream' | 'cream-deep' (default: none).
defineProps({
  bg: { type: String, default: '', validator: (v) => ['', 'cream', 'cream-deep'].includes(v) },
})

const route = useRoute()
const shouldFade = ref(false)
const clicked = ref(false)
const ASSETS_CDN = assetCDN()

const showMore = () => {
  clicked.value = true
  shouldFade.value = false
}

const generalStore = useGeneralInfoStore()

const windowWidth = computed(
  () => generalStore.generalData.windowWidth,
)

watch(
  () => windowWidth.value,
  (value) => {
    if (clicked.value) return
    else if (value < PHONE) {
      shouldFade.value = true
    } else {
      shouldFade.value = false
    }
  },
)

onMounted(() => {
  if (windowWidth.value < PHONE) {
    shouldFade.value = true
  }
})

const content = computed(() => {
  const listItem = route.name === SCHOOL_TOUR_ROUTE.name ? SCHOOL_BENEFITS_FIRST_LIST(ASSETS_CDN) : BENEFITS_FIRST_LIST(ASSETS_CDN)
  const listSecond = route.name === SCHOOL_TOUR_ROUTE.name ? SCHOOL_BENEFITS_SECOND_LIST(ASSETS_CDN) : BENEFITS_SECOND_LIST(ASSETS_CDN)

  if (windowWidth.value > PHONE) {
    return listItem.concat(listSecond)
  } else {
    if (clicked.value) {
      return listItem.concat(listSecond)
    } else {
      return listItem
    }
  }
})

const headerText = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return SCHOOL_BENEFITS_HEADER
  return BENEFITS_HEADER
})
</script>

<style lang="scss" scoped>
.show-more-background {
  height: 70px;
  background: linear-gradient(
    180deg,
    rgba($cream, 0) 0%,
    $cream 32.81%
  ); // v2 — fade into the cream canvas (was #ffffff)
}

.fade {
  mask-image: linear-gradient(180deg, #000 80%, transparent);
}
</style>
